import { useNavigate } from 'react-router-dom'

import { TrainingsTabsDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { BudgetsDataCollection } from 'modules/finance/components/Budgets/BudgetsDataCollection'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const BudgetsList = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { company } = useCurrentSession()

  const { data, loading, error } = useQuery(TrainingsTabsDocument, {
    variables: {
      companyId: company.id,
    },
  })

  const canViewTrainingBudgets =
    data?.finance?._policies?.budgetsViewTrainingBudgets?.can ?? false
  const canManageTrainingBudgets =
    data?.finance?._policies?.budgetsManageTrainingBudgets?.can ?? false

  return (
    <ResponsivePage.Body
      variant="full"
      loading={loading}
      error={error}
      authorized={canViewTrainingBudgets || canManageTrainingBudgets}
    >
      <BudgetsDataCollection
        canManageBudgets={canManageTrainingBudgets}
        canCreateBudgets={canManageTrainingBudgets}
        budgetableBy="training_class"
        onAddBudget={() => {
          navigate(navigation.trainings.budgets.new.fullPath())
        }}
        onItemClick={(item) => {
          navigate(
            navigation.trainings.budgets.detail.fullPath({ budgetId: item.id })
          )
        }}
      />
    </ResponsivePage.Body>
  )
}

export default BudgetsList
